import { EPData, MarkerIcon } from '@rsos/assets/icons';
import { Checkbox } from './ShareEvent.types';

const dataSources: Checkbox[] = [
  {
    label: 'Location',
    description: 'Current and location history',
    disabled: false,
    isChecked: false,
    id: 'incident_location',
    icon: MarkerIcon,
  },
  {
    label: 'Caller Data',
    description: 'Caller additional data request(ADR)',
    disabled: false,
    isChecked: false,
    id: 'additional_data',
    icon: EPData,
  },
];

export default dataSources;
